export const BASE_URL = "https://online.bleepshare.com/public/";
export const API_BASE = "https://bleepshare.tech/applicationdata";
